
import { Button } from "@/components/ui/button";
import { PropertyCard } from "@/components/PropertyCard";
import { Listing } from "@/lib/types";

interface FeaturedPropertiesSectionProps {
  featuredProperties: Listing[];
  isLoading: boolean;
  displayMode: "grid" | "list";
  handleClearFilters: () => void;
  getPropertyBoostedStatus: (id: number | string) => boolean;
}

const FeaturedPropertiesSection = ({
  featuredProperties = [],
  isLoading,
  handleClearFilters,
  getPropertyBoostedStatus,
}: FeaturedPropertiesSectionProps) => {
  // Limit to exactly 3 featured properties
  const limitedFeaturedProperties = featuredProperties.slice(0, 3);

  if (isLoading || limitedFeaturedProperties.length === 0) return null;

  return (
    <div className="mb-8">
      <div className="flex justify-between items-center mb-4">
        <h2 className="text-lg font-semibold text-gray-800">Featured Properties</h2>
        <Button variant="ghost" onClick={handleClearFilters} className="text-sm">
          View All Featured
        </Button>
      </div>
      
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
        {limitedFeaturedProperties.map((property) => (
          <PropertyCard
            key={property.id}
            property={{
              ...property,
              isBoosted: getPropertyBoostedStatus(property.id)
            }}
          />
        ))}
      </div>
    </div>
  );
};

export default FeaturedPropertiesSection;
